<script>
export default {
  inject: ['itemClass'],
  mounted() {
    this.$el.classList.add(this.itemClass);
  },
  render() {
    return this.$slots.default[0];
  },
};
</script>